var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-seven-year-wrapper",attrs:{"id":_vm.componentId}},[_c('div',{staticClass:"sp-seven-year"},[_c('img',{staticClass:"year-icon",attrs:{"src":require("./images/year-icon.png"),"alt":""}}),_c('div',{staticClass:"year-background"},[_c('span',{staticClass:"year-text"},[_vm._v(_vm._s(_vm.year))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }